"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.exitDetails = exports.TRANSLATION = void 0;
var TRANSLATION = {
  exit: 'Exit'
};
exports.TRANSLATION = TRANSLATION;
var exitDetails = {
  color: '#F2F3F6'
};
exports.exitDetails = exitDetails;